import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { useState as c, Children as f, cloneElement as p } from "react";
import { tv as n } from "tailwind-variants";
import { H as v } from "./chunks/index-UjijAVoZ.js";
import d from "./Images.js";
import g from "./Step.js";
const u = n({
  base: ["gap-6"],
  variants: {
    hasHeading: {
      true: ["grid", "tablet:grid-cols-2"],
      false: [
        "flex",
        "flex-col",
        "items-center",
        "*:w-full",
        "tablet:flex-row-reverse",
        "tablet:*:w-1/2"
      ]
    }
  }
}), x = ({ children: a, className: r, heading: e }) => {
  const [l, o] = c(0);
  return /* @__PURE__ */ m("div", { className: u({ class: r, hasHeading: !!e }), children: [
    e && /* @__PURE__ */ s(v, { className: "self-end", level: "1", tagName: "h2", children: e }),
    /* @__PURE__ */ s(d, { activeStep: l, children: a }),
    /* @__PURE__ */ s("div", { className: "flex flex-col gap-4", children: f.map(a, (i, t) => p(i, {
      isActive: l === t,
      index: t,
      onClick: () => o(t)
    })) })
  ] });
};
x.Step = g;
export {
  x as default
};
